module.exports = __webpack_public_path__ + "static/media/asset_mgmt.2a15d59d.png";